import { useRef, useState, useEffect } from 'react';
import { useAudio } from './contexts/AudioContext';

const podcastLinks = {
  spotify: "https://open.spotify.com/show/0pVfkdbpQWM9sKlhzpbQq6",
  apple: "https://podcasts.apple.com/podcast/id1806225838",
  youtube: null,
  buzzsprout: "https://feeds.buzzsprout.com/2466760.rss",
  podcastAddict: "https://podcastaddict.com/podcast/test/5789564",
}

const SkipBackButton = ({className, handleSkip}: {className?: string, handleSkip: (seconds: number) => void}) => <button
    type="button"
    onClick={() => handleSkip(-10)}
    className={`rounded-full h-[16px] w-[16px] flex items-center justify-center hover:text-[var(--accent)] ${className}`}
    aria-label="Skip backward 30 seconds"
  >
    <svg width="100%" height="100%" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
      <path d="m276 732v204c0 17.148 9.1484 32.996 24 41.57 14.852 8.5742 33.148 8.5742 48 0 14.852-8.5742 24-24.422 24-41.57v-204c0-25.461-10.113-49.879-28.117-67.883-18.004-18.004-42.422-28.117-67.883-28.117-17.148 0-32.996 9.1484-41.57 24-8.5742 14.852-8.5742 33.148 0 48 8.5742 14.852 24.422 24 41.57 24" />
      <path d="m444 768v84c0 47.16 25.16 90.734 66 114.32 40.84 23.578 91.16 23.578 132 0 40.84-23.582 66-67.156 66-114.32v-84c0-47.16-25.16-90.734-66-114.32-40.84-23.578-91.16-23.578-132 0-40.84 23.582-66 67.156-66 114.32m168 0v84c0 12.863-6.8633 24.746-18 31.176-11.137 6.4336-24.863 6.4336-36 0-11.137-6.4297-18-18.312-18-31.176v-84c0-12.863 6.8633-24.746 18-31.176 11.137-6.4336 24.863-6.4336 36 0 11.137 6.4297 18 18.312 18 31.176" />
      <path d="m312 396c-0.054688 28.109 11.137 55.074 31.078 74.879l91.082 91.082c12.133 12.133 29.816 16.871 46.391 12.43s29.52-17.387 33.961-33.961c4.4375-16.574-0.30078-34.258-12.434-46.391l-50.156-50.039h268.08c42.711 0.16016 83.488 17.828 112.82 48.875 29.328 31.051 44.645 72.77 42.371 115.42-2.2695 42.652-21.93 82.508-54.391 110.27-13.121 11.148-19.297 28.445-16.203 45.383 3.0977 16.934 14.988 30.93 31.203 36.719 16.211 5.7891 34.281 2.4883 47.398-8.6602 39.297-33.406 67.398-78.062 80.508-127.95 13.109-49.883 10.598-102.59-7.1953-151-17.797-48.406-50.016-90.191-92.309-119.71-42.293-29.52-92.629-45.348-144.2-45.352h-268.08l50.039-50.039c12.133-12.133 16.871-29.816 12.43-46.391-4.4414-16.574-17.387-29.52-33.961-33.961-16.574-4.4414-34.258 0.29688-46.391 12.43l-91.078 91.078v0.003906c-19.902 19.828-31.047 46.789-30.961 74.879" />
    </svg>
  </button>;

  const SkipForwardButton = ({className, handleSkip}: {className?: string, handleSkip: (seconds: number) => void}) => <button
    type="button"
    onClick={() => handleSkip(10)}
    className={`rounded-full h-[16px] w-[16px] flex items-center justify-center hover:text-[var(--accent)] ${className}`}
    aria-label="Skip forward 30 seconds"
  >
    <svg width="100%" height="100%" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
      <path d="m588 984c12.73 0 24.938-5.0586 33.941-14.059 9-9.0039 14.059-21.211 14.059-33.941v-204c0-25.461-10.113-49.879-28.117-67.883-18.004-18.004-42.422-28.117-67.883-28.117-17.148 0-32.996 9.1484-41.57 24-8.5742 14.852-8.5742 33.148 0 48 8.5742 14.852 24.422 24 41.57 24v204c0 12.73 5.0586 24.938 14.059 33.941 9.0039 9 21.211 14.059 33.941 14.059" />
      <path d="m972 768c0-47.16-25.16-90.734-66-114.32-40.84-23.578-91.16-23.578-132 0-40.84 23.582-66 67.156-66 114.32v84c0 47.16 25.16 90.734 66 114.32 40.84 23.578 91.16 23.578 132 0 40.84-23.582 66-67.156 66-114.32zm-96 84c0 12.863-6.8633 24.746-18 31.176-11.137 6.4336-24.863 6.4336-36 0-11.137-6.4297-18-18.312-18-31.176v-84c0-12.863 6.8633-24.746 18-31.176 11.137-6.4336 24.863-6.4336 36 0 11.137 6.4297 18 18.312 18 31.176" />
      <path d="m228 600c0.003906 36.527 7.9453 72.617 23.277 105.77 15.332 33.152 37.691 62.574 65.523 86.23 13.055 11.125 31.051 14.441 47.215 8.6992 16.16-5.7422 28.031-19.672 31.141-36.543 3.1055-16.867-3.0234-34.109-16.078-45.234-32.656-27.727-52.473-67.664-54.801-110.44-2.332-42.773 13.031-84.625 42.484-115.73s70.398-48.738 113.24-48.75h244.08l-50.039 50.039c-12.133 12.133-16.871 29.816-12.43 46.391 4.4414 16.574 17.387 29.52 33.961 33.961 16.574 4.4414 34.258-0.29688 46.391-12.43l91.078-91.078v-0.003906c19.883-19.871 31.051-46.828 31.051-74.938s-11.168-55.07-31.051-74.941l-91.078-91.078c-12.133-12.133-29.816-16.871-46.391-12.434-16.574 4.4414-29.52 17.387-33.961 33.961s0.29688 34.258 12.43 46.391l50.039 50.16h-244.08c-66.836 0-130.93 26.551-178.19 73.809-47.258 47.258-73.809 111.36-73.809 178.19" />
    </svg>
  </button>;

  const SpeedAdjust = ({className, setPlaybackRate, playbackRate}: {className?: string, setPlaybackRate: (rate: number) => void, playbackRate: number}) => <select
    value={playbackRate}
    onChange={(e) => setPlaybackRate(parseFloat(e.target.value))}
    style={{
      width: (playbackRate.toString().length * 7 + 7) + 'px'
    }}
    className={`bg-transparent border-none text-xs focus:outline-none cursor-pointer appearance-none ${className}`}
  >
    <option value="0.5">0.5x</option>
    <option value="0.75">0.75x</option>
    <option value="1">1x</option>
    <option value="1.25">1.25x</option>
    <option value="1.5">1.5x</option>
    <option value="2">2x</option>
    <option value="2.5">2.5x</option>
    <option value="3">3x</option>
    <option value="4">4x</option>
    <option value="5">5x</option>
  </select>;

export default function AudioPlayer() {
  const {
    isPlaying,
    duration,
    currentTime,
    hasPlayedBefore,
    isLoading,
    isVisible,
    togglePlayPause,
    setCurrentTime,
    formatTime,
    setPlaybackRate,
    playbackRate
  } = useAudio();

  const progressBarRef = useRef<HTMLDivElement>(null);

  // Seek to a specific time in the audio when clicking the progress bar
  const handleProgressBarClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!progressBarRef.current || duration === 0) return;

    // Calculate click position as a percentage of the bar width
    const rect = progressBarRef.current.getBoundingClientRect();
    const clickPositionX = e.clientX - rect.left;
    const percentageClicked = clickPositionX / rect.width;

    // Set the new time based on the percentage of the duration
    const newTime = percentageClicked * duration;
    setCurrentTime(newTime);
  };

  // Handle skip forward/backward
  const handleSkip = (seconds: number) => {
    const newTime = Math.max(0, Math.min(duration, currentTime + seconds));
    setCurrentTime(newTime);
  };

  // Calculate if we should show the player (visible by prop OR was playing while hidden)
  const shouldShow = isVisible

  

  return <div className={`group pt-3 transition-opacity duration-500 ${!shouldShow ? 'opacity-0' : 'opacity-100'}`}>
    <div className="flex w-full">
      <button
        type="button"
        onClick={togglePlayPause}
        className="md:hidden mr-1 rounded-full h-[26px] w-[26px] flex items-center justify-center hover:fill-[var(--accent)]"
        aria-label={isPlaying ? "Pause audio" : "Play audio of page text"}
      >
        {isPlaying ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        ) : (
          <svg className="hover:text-[var(--accent)]" xmlns="http://www.w3.org/2000/svg" width="16" viewBox="0 0 9 16"><path d="M0 11.9523V4.04773C0 3.22232 0.911256 2.72209 1.60763 3.16523L7.81833 7.1175C8.46426 7.52854 8.46426 8.47146 7.81833 8.8825L1.60763 12.8348C0.911255 13.2779 0 12.7777 0 11.9523Z" fill="currentColor"></path></svg>
        )}
      </button>
      <div className="flex flex-col w-full">
        {/* Progress bar - only show if user has played audio before */}
        {duration > 0 && hasPlayedBefore && (
          <div
            ref={progressBarRef}
            onClick={handleProgressBarClick}
            className="w-full bg-gray-200 h-1 rounded-full my-1 cursor-pointer"
          >
            <div
              className="bg-[var(--accent)] h-1 rounded-full pointer-events-none"
              style={{ width: `${(currentTime / duration) * 100}%` }}
            />
          </div>
        )}

        <div className="flex items-center font-sans">
          <button
            type="button"
            onClick={togglePlayPause}
            className="rounded-full h-[16px] flex items-center justify-center hover:fill-[var(--accent)] hidden md:block"
            aria-label={isPlaying ? "Pause audio" : "Play audio of page text"}
          >
            {isPlaying ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="6" y="4" width="4" height="16"></rect>
                <rect x="14" y="4" width="4" height="16"></rect>
              </svg>
            ) : (
              <svg className="hover:text-[var(--accent)]" xmlns="http://www.w3.org/2000/svg" width="8" viewBox="0 0 9 16"><path d="M0 11.9523V4.04773C0 3.22232 0.911256 2.72209 1.60763 3.16523L7.81833 7.1175C8.46426 7.52854 8.46426 8.47146 7.81833 8.8825L1.60763 12.8348C0.911255 13.2779 0 12.7777 0 11.9523Z" fill="currentColor"></path></svg>
            )}
          </button>

          <span className="w-full">
            <div className="flex items-center justify-between font-mono text-xs md:ml-2">
              <div className="flex items-center gap-2">
                <span className="hidden md:block">{isPlaying ? "Narrated by Perrin Walker" : "Listen to this scenario"}</span>
                <span className="block md:hidden text-[10px]">{Object.values(podcastLinks).some(link => link) ?  <AlsoAvailableOn /> : "Listen"}</span>
              </div>
              <div className="hidden sm:flex items-center gap-2 ml-auto ">
                <SkipBackButton handleSkip={handleSkip} />
                <SpeedAdjust setPlaybackRate={setPlaybackRate} playbackRate={playbackRate} />
                <SkipForwardButton handleSkip={handleSkip} />
              </div>
              <div className="pl-3">
                {isLoading ? "0:00 / 3:23" : `${formatTime(currentTime)} / ${formatTime(duration)}`}
              </div>
            </div>
          </span>
        </div>

        <div className={`hidden md:block mt-2 ${currentTime > 10 ? 'opacity-0 group-hover:opacity-100 transition-opacity duration-300' : 'opacity-100'}`}>
          <AlsoAvailableOn />
        </div>
      </div>
      <div className="flex items-center gap-2 ml-2 sm:hidden font-sans">
        <SkipBackButton handleSkip={handleSkip} className="h-[18px] w-[18px]" />
        <SpeedAdjust setPlaybackRate={setPlaybackRate} playbackRate={playbackRate} className="!text-sm"/>
        <SkipForwardButton handleSkip={handleSkip} className="h-[18px] w-[18px]" />
      </div>

    </div>
  </div>
}

const AlsoAvailableOn = () => <div className="flex items-center justify-end gap-1 opacity-70 font-mono text-xs">
  {(podcastLinks.spotify || podcastLinks.youtube || podcastLinks.apple || podcastLinks.buzzsprout || podcastLinks.podcastAddict) && <span className="text-[7px] sm:text-xs mr-1">also available on</span>}
  {podcastLinks.spotify && <a href={podcastLinks.spotify} className="hover:opacity-70 transition-opacity" aria-label="Listen on Spotify">
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 sm:w-4 sm:h-4">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
    </svg>
  </a>}
  {podcastLinks.youtube && <a href={podcastLinks.youtube} className="hover:opacity-70 transition-opacity" aria-label="Listen on YouTube">
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 sm:w-4 sm:h-4">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  </a>}
  {podcastLinks.apple && <a href={podcastLinks.apple} className="hover:opacity-70 transition-opacity" aria-label="Listen on Apple Podcasts">
    <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 sm:w-4 sm:h-4">
      <path d="M7.12 0c-3.937-0.011-7.131 3.183-7.12 7.12v17.76c-0.011 3.937 3.183 7.131 7.12 7.12h17.76c3.937 0.011 7.131-3.183 7.12-7.12v-17.76c0.011-3.937-3.183-7.131-7.12-7.12zM15.817 3.421c3.115 0 5.932 1.204 8.079 3.453 1.631 1.693 2.547 3.489 3.016 5.855 0.161 0.787 0.161 2.932 0.009 3.817-0.5 2.817-2.041 5.339-4.317 7.063-0.812 0.615-2.797 1.683-3.115 1.683-0.12 0-0.129-0.12-0.077-0.615 0.099-0.792 0.192-0.953 0.64-1.141 0.713-0.296 1.932-1.167 2.677-1.911 1.301-1.303 2.229-2.932 2.677-4.719 0.281-1.1 0.244-3.543-0.063-4.672-0.969-3.595-3.907-6.385-7.5-7.136-1.041-0.213-2.943-0.213-4 0-3.636 0.751-6.647 3.683-7.563 7.371-0.245 1.004-0.245 3.448 0 4.448 0.609 2.443 2.188 4.681 4.255 6.015 0.407 0.271 0.896 0.547 1.1 0.631 0.447 0.192 0.547 0.355 0.629 1.14 0.052 0.485 0.041 0.62-0.072 0.62-0.073 0-0.62-0.235-1.199-0.511l-0.052-0.041c-3.297-1.62-5.407-4.364-6.177-8.016-0.187-0.943-0.224-3.187-0.036-4.052 0.479-2.323 1.396-4.135 2.921-5.739 2.199-2.319 5.027-3.543 8.172-3.543zM16 7.172c0.541 0.005 1.068 0.052 1.473 0.14 3.715 0.828 6.344 4.543 5.833 8.229-0.203 1.489-0.713 2.709-1.619 3.844-0.448 0.573-1.537 1.532-1.729 1.532-0.032 0-0.063-0.365-0.063-0.803v-0.808l0.552-0.661c2.093-2.505 1.943-6.005-0.339-8.296-0.885-0.896-1.912-1.423-3.235-1.661-0.853-0.161-1.031-0.161-1.927-0.011-1.364 0.219-2.417 0.744-3.355 1.672-2.291 2.271-2.443 5.791-0.348 8.296l0.552 0.661v0.813c0 0.448-0.037 0.807-0.084 0.807-0.036 0-0.349-0.213-0.683-0.479l-0.047-0.016c-1.109-0.885-2.088-2.453-2.495-3.995-0.244-0.932-0.244-2.697 0.011-3.625 0.672-2.505 2.521-4.448 5.079-5.359 0.547-0.193 1.509-0.297 2.416-0.281zM15.823 11.156c0.417 0 0.828 0.084 1.131 0.24 0.645 0.339 1.183 0.989 1.385 1.677 0.62 2.104-1.609 3.948-3.631 3.005h-0.015c-0.953-0.443-1.464-1.276-1.475-2.36 0-0.979 0.541-1.828 1.484-2.328 0.297-0.156 0.709-0.235 1.125-0.235zM15.812 17.464c1.319-0.005 2.271 0.463 2.625 1.291 0.265 0.62 0.167 2.573-0.292 5.735-0.307 2.208-0.479 2.765-0.905 3.141-0.589 0.52-1.417 0.667-2.209 0.385h-0.004c-0.953-0.344-1.157-0.808-1.553-3.527-0.452-3.161-0.552-5.115-0.285-5.735 0.348-0.823 1.296-1.285 2.624-1.291z" />
    </svg>
  </a>}
  {podcastLinks.buzzsprout && <a href={podcastLinks.buzzsprout} className="hover:opacity-70 transition-opacity" aria-label="Listen on Buzzsprout">
    {/* Generic RSS Icon for Buzzsprout */}
    <svg version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 sm:w-4 sm:h-4">
      <path d="m1028.2 78.801h-856.36c-51.121 0-92.578 41.461-92.578 92.578v850.58c0 51.121 41.461 92.578 92.578 92.578h856.36c51.121 0 92.578-41.441 92.578-92.578l0.003907-850.58c0-51.117-41.461-92.578-92.582-92.578zm-675.86 879.78c-52.719 0-95.48-42.781-95.48-95.48 0-52.762 42.762-95.48 95.48-95.48 52.699 0 95.48 42.719 95.48 95.48 0 52.723-42.781 95.48-95.48 95.48zm364.14 0h-98c0.57812-8.4609 1.2617-16.82 1.2617-25.422 0-200.52-163.18-363.72-363.72-363.72h-0.039062v-98h0.039062c254.6 0 461.74 207.12 461.74 461.72-0.023438 8.625-0.84375 16.945-1.2812 25.422zm219.5 0h-92.801c5.6016-31.059 9-62.84 9-95.48 0-295.82-240.66-536.5-536.5-536.5-20.199 0-40.078 1.3594-59.719 3.5195v-92.359c19.66-1.8594 39.559-3.0391 59.719-3.0391 346.46 0 628.36 281.9 628.36 628.36 0 32.582-3.2578 64.262-8.0586 95.5z"/>
    </svg>
  </a>}
</div>
